import { useEffect } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Button } from 'react-bootstrap';
import { BASE_SITE, USER_WALLET_TRANS_POST } from '../../../../apis'; 
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleChangeDataWalletPage } from '../../../../redux/actions/pages/wallet';
import { handleChangeProfileData } from "../../../../redux/actions/pages/user/user";
import { handleChangeDataBottomSheet } from '../../../../redux/actions/partials/footer/bottom_sheet';
import axios from "axios";
import * as qs from "querystring";
import CloseIcon from '../../../../styles/images/close.png';
import EmptyWallet from '../../../../styles/images/empty-wallet.png';
import CardWalletTrans from './cardWalletTrans';
import Swal from 'sweetalert2';
import SitagLogo from '../../../../styles/images/sitag-logo.png';


const Wallet = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { token, profile } = useSelector(state => state.user);
    const { trans } = useSelector(state => state.wallet);

    useEffect(() => {
        callApiGetWalletTrans();
        // eslint-disable-next-line
    }, [Wallet]);

    const callApiGetWalletTrans = () => {
        dispatch(handleSetBackdropLoading(true));

        axios({
            method: 'post',
            url: BASE_SITE + USER_WALLET_TRANS_POST,
            data: qs.stringify({
                offset: '0',
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': (!!token ? token : '')
            },
        }).then((response) => {
            switch (response.data.status) {
                case 'error':
                    dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                    break;
                case 'ok':
                    let newProfile = {...profile, 
                        user_credit: response.data.total.user_credit, 
                        user_org_credit: response.data.total.user_org_credit, 
                    }
                    dispatch(handleChangeProfileData(newProfile));
                    dispatch(handleChangeDataWalletPage('trans', response.data.transactions));
                    break;
                default:
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در خروج! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
            }
            dispatch(handleSetBackdropLoading(false));
        }, () => {
            dispatch(handleSetBackdropLoading(false));
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در خروج! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
        });
    };

    const handleBackBtn = () => {
        navigate('/', { replace: true });
    };


    const closeBottomSheet = () => {
        dispatch(handleChangeDataBottomSheet('isOpen', false));
    };

    const btnOkSingle = Swal.mixin({
        customClass: {
            confirmButton: 'primary-border primary-txt-color font-weight-300 radius-12 w-100 py-2 px-5',
        },
        buttonsStyling: false
    });

    const handleShowWithdrawAlert = () => {
        btnOkSingle.fire({
            title: "تایید",
            text: `در حال حاضر این سرویس در  دسترس  نمیباشد`,
            imageUrl: SitagLogo,
            imageHeight: 80,
            imageAlt: 'سیتگ',
            confirmButtonText: "باشه",
        });
    };

    return (

        <div id="wallet-page" onClick={closeBottomSheet} >

            <Row className="py-3 white-bg sticky top-0 z-index-2">
                <Col xs={2}></Col>
                <Col xs={8} className="d-flex align-items-center justify-content-center"><h4 className="text-center mb-0">کیف پول</h4></Col>
                <Col xs={2}><img src={CloseIcon} alt="back" onClick={handleBackBtn} role="button" /></Col>
            </Row>


            <div className="w-100 wallet-info p-3 mt-4">
                <Row className="primary-color-label">
                    <Col xs={6} className="text-left">
                        موجودی کیف پول:
                    </Col>
                    <Col xs={6} className="text-right">
                        <strong>{(profile.user_credit + profile.user_org_credit).toLocaleString()}  </strong>
                        <small> ریال</small>
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col xs={6} className="text-left">
                        <Link to="../charge-wallet">
                            <Button className="text-center w-100 primary-btn py-2">
                                شارژ کیف پول
                            </Button>
                        </Link>
                    </Col>
                    <Col xs={6} className="text-right">
                        {/*<Link to="../withdraw">*/}
                        <Link to="" onClick={handleShowWithdrawAlert}>
                            <Button className="text-center w-100 primary-btn py-2">
                                برداشت وجه
                            </Button>
                        </Link>
                    </Col>
                </Row>
            </div>

            <h4 className="text-left my-4">تاریخچه کیف پول</h4>


            { trans !== undefined && trans.length === 0 ?
                <div className="text-center mt-5">
                    <img src={EmptyWallet} width={200} alt="no record" />
                    <p className="mt-3 no-record-txt font-size-22 font-weight-400">موردی برای نمایش وجود ندارد</p>
                </div>
            
            :
                trans.map((item, key) => {
                    return (
                        <CardWalletTrans data={{item}} key={key} />
                    );
                })
            }

        </div>
    );
}

export default Wallet;